import { createFileRoute } from "@tanstack/react-router";
import { ResearchConsultingServicePage } from "./services_.research-consulting";

export const Route = createFileRoute("/services_/research-consulting-and-campaign-audit-services")({
  head: () => ({
    meta: [
      {
        title: "Research Consulting & Campaign Audit Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Performance Evaluation & Campaign ROI Audits.",
      },
    ],
  }),
  component: ResearchConsultingServicePage,
});
